"use client"

import { SquareParking } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SquareParkingIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SquareParkingIcon = component(Icon)({ as: SquareParking })
